import axios from "axios";
import { JSON_URL } from "../../config/RouterLink";
import { MALA_ACCION } from "../../utils";

//------------- TYPES -------------------------

const GET_OBT_SISTEMA = "GET_OBT_SISTEMA";
const GET_SISTEMA_INE = "[VACANTES] GET_SISTEMA_INE";
const GET_SISTEMA_OPLE = "[VACANTES] GET_SISTEMA_OPLE";
const OBTENER_VALOR_BANDERA = "[VACANTES] OBTENER_VALOR_BANDERA";
const GET_CONCURSO = "[VACANTES] GET_CONCURSO";
const ASIGNAR_ID_TIPO_CONCURSO = "[VACANTES] ASIGNAR_ID_TIPO_CONCURSO";
const GET_CONCURSO_ERROR = "[VACANTES]GET_CONCURSO_ERROR";
const GET_CONCURSO_SERVICE = "[VACANTES]GET_CONCURSO_SERVICE";
const GET_CONVOCATORIA = "[VACANTES] GET_CONVOCATORIA";
const GET_CONVOCATORIA_ERROR = "[VACANTES]GET_CONCURSO_ERROR";
const GET_CONVOCATORIA_SERVICE = "[VACANTES]GET_CONCURSO_SERVICE";
const GET_OBT_SISTEMA_ERROR = "GET_OBT_SISTEMA_ERROR";
const GET_OBT_SISTEMA_SERVICE = "GET_OBT_SISTEMA_SERVICE";
const GET_MATERIALES_APOYO_INE = "[VACANTES] GET_MATERIALES_APOYO_INE";
const GET_MATERIALES_APOYO_OPLE = "[VACANTES] GET_MATERIALES_APOYO_OPLE";
const CLEAN_STATE_SISTEMAS = "CLEAN_STATE_SISTEMAS";
const GET_REGISTRARME = "GET_REGISTRARME";
const GET_INICIAR_SESION = "GET_INICIAR_SESION";
const GET_FECHA_POSTULACION = "GET_FECHA_POSTULACION";

//------------- STATE -------------------------

const datosIniciales = {
  //Sistema general id
  sistemas: [],
  message: "",
  //Convocatorias activas por sistema INE/OPLE
  sistemaINE: {},
  sistemaOPLE: {},
  bandera: null,
  //Obtener concursos activos y convocatoria
  concursos: {},
  idTipoConcurso: null,
  idSistema: null,
  convocatorias: {},
  //Link para materiales de apoyo home publico
  materialesINE: null,
  materialesOPLE: null,
  get_registro: null,
  get_iniciarSesion:null,
  get_FechaPostulacion:null,
};

//------------- REDUCER -------------------------
const obtenerSistemaReducer = (state = datosIniciales, action) => {
  switch (action.type) {
    case GET_OBT_SISTEMA:
      return {
        ...state,
        sistemas: action.payload,
      };

    case GET_SISTEMA_INE:
      return {
        ...state,
        sistemaINE: action.payload[0],
      };
    case GET_SISTEMA_OPLE:
      return {
        ...state,
        sistemaOPLE: action.payload[0],
      };
    case OBTENER_VALOR_BANDERA:
      return {
        ...state,
        bandera: action.payload,
      };
    case GET_OBT_SISTEMA_ERROR:
      return {
        ...state,
        message: MALA_ACCION,
        sistemas: [],
      };
    case GET_OBT_SISTEMA_SERVICE:
      return {
        ...state,
        sistemas: [],
      };
    case GET_CONCURSO:
      return {
        ...state,
        concursos: action.payload,
      };
    case ASIGNAR_ID_TIPO_CONCURSO:
      return {
        ...state,
        idTipoConcurso: action.payload,
      };
    case GET_CONCURSO_ERROR:
      return {
        ...state,
        message: MALA_ACCION,
        concursos: {},
      };
    case GET_CONCURSO_SERVICE:
      return {
        ...state,
        concursos: {},
      };
    case GET_CONVOCATORIA:
      return {
        ...state,
        convocatorias: action.payload,
      };
    case GET_CONVOCATORIA_ERROR:
      return {
        ...state,
        message: MALA_ACCION,
        convocatorias: {},
      };
    case GET_CONVOCATORIA_SERVICE:
      return {
        ...state,
        convocatorias: {},
      };
    case GET_MATERIALES_APOYO_INE:
      return {
        ...state,
        materialesINE: action.payload,
      };
    case GET_MATERIALES_APOYO_OPLE:
      return {
        ...state,
        materialesOPLE: action.payload,
      };
      case GET_REGISTRARME:
      return {
        ...state,
        get_registro: action.payload,
      };
      case GET_INICIAR_SESION:
      return {
        ...state,
        get_iniciarSesion: action.payload,
      };
      case GET_FECHA_POSTULACION:
      return {
        ...state,
        get_FechaPostulacion: action.payload,
      };
    case CLEAN_STATE_SISTEMAS:
      return datosIniciales;

    default:
      return state;
  }
};

export default obtenerSistemaReducer;

//------------- ACTIONS -------------------------

export const getObtSistemas = (state) => ({
  type: GET_OBT_SISTEMA,
  payload: state,
});

export const getConcursos = (state) => ({
  type: GET_CONCURSO,
  payload: state,
});

export const getConvocatorias = (state) => ({
  type: GET_CONVOCATORIA,
  payload: state,
});

export const asignarTipoConcurso = (idTipoConcurso) => async (dispatch) => {
  dispatch({
    type: ASIGNAR_ID_TIPO_CONCURSO,
    payload: idTipoConcurso,
  });
};

export const getObtSistemaINE = (state) => ({
  type: GET_SISTEMA_INE,
  payload: state,
});

export const getObtSistemaOPLE = (state) => ({
  type: GET_SISTEMA_OPLE,
  payload: state,
});

export const Obtener_Bandera = (state) => ({
  type: OBTENER_VALOR_BANDERA,
  payload: state,
});

export const linkMaterialesINE = (state) => ({
  type: GET_MATERIALES_APOYO_INE,
  payload: state,
});

export const linkMaterialesOPLE = (state) => ({
  type: GET_MATERIALES_APOYO_OPLE,
  payload: state,
});

export const cleanSistemas = () => ({
  type: CLEAN_STATE_SISTEMAS,
});

export const paramRegistrarme = (state) => ({
  type: GET_REGISTRARME,
  payload: state,
});

export const paramIniciarSesion = (state) => ({
  type: GET_INICIAR_SESION,
  payload: state,
});

export const paramFechaPostulacion = (state) => ({
  type: GET_FECHA_POSTULACION,
  payload: state,
});


export const obtenerSistema = () => async (dispatch, getState) => {
  try {
    const urls = await axios(window.location.origin + JSON_URL);
    const { data } = await axios.post(
      `${urls.data.urlServer}${urls.data.urlObtenerSistema}`
    );
    dispatch(getObtSistemas(data));
  } catch (error) {
    if (!error.response) {
      dispatch({
        type: GET_OBT_SISTEMA_SERVICE,
      });
    } else {
      dispatch({
        type: GET_OBT_SISTEMA_ERROR,
        payload: error.response.data,
      });
    }
  }
};

export const BanderaPostula = () => async (dispatch, getState) => {
  try {
    const urls = await axios(window.location.origin + JSON_URL);
    const { data } = await axios.post(
      `${urls.data.urlServer}${urls.data.urlBanderaPostulacion}`
    );
    dispatch(Obtener_Bandera(data));
  } catch (error) {
    if (!error.response) {
      dispatch({
        type: OBTENER_VALOR_BANDERA,
      });
    } else {
      dispatch({
        type: GET_OBT_SISTEMA_ERROR,
        payload: error.response.data,
      });
    }
  }
};

export const obtenerSistemaINE = () => async (dispatch, getState) => {
  try {
    const urls = await axios(window.location.origin + JSON_URL);
    const { data } = await axios.post(
      `${urls.data.urlServer}${urls.data.urlObtenerSistemaINE}`
    );
    dispatch(getObtSistemaINE(data));
  } catch (error) {
    if (!error.response) {
      dispatch({
        type: GET_OBT_SISTEMA_SERVICE,
      });
    } else {
      dispatch({
        type: GET_OBT_SISTEMA_ERROR,
        payload: error.response.data,
      });
    }
  }
};

export const obtenerSistemaOPLE = () => async (dispatch, getState) => {
  try {
    const urls = await axios(window.location.origin + JSON_URL);
    const { data } = await axios.post(
      `${urls.data.urlServer}${urls.data.urlObtenerSistemaOPLE}`
    );
    dispatch(getObtSistemaOPLE(data));
  } catch (error) {
    if (!error.response) {
      dispatch({
        type: GET_OBT_SISTEMA_SERVICE,
      });
    } else {
      dispatch({
        type: GET_OBT_SISTEMA_ERROR,
        payload: error.response.data,
      });
    }
  }
};

export const obtenerConcursos = (idSistema) => async (dispatch) => {
  try {
    const urls = await axios(window.location.origin + JSON_URL);
    const { data } = await axios.post(
      `${urls.data.urlServer}${urls.data.urlObtenerConcurso}`,
      {
        idSistema,
      }
    );
    dispatch(getConcursos(data));
  } catch (error) {
    if (!error.response) {
      dispatch({
        type: GET_CONCURSO_SERVICE,
      });
    } else {
      dispatch({
        type: GET_CONCURSO_ERROR,
        payload: error.response.data,
      });
    }
  }
};

export const obtenerConvocatorias = (idSistema) => async (dispatch) => {
  try {
    const urls = await axios(window.location.origin + JSON_URL);
    const { data } = await axios.post(
      `${urls.data.urlServer}${urls.data.urlObtenerConvocatoria}`,
      {
        idSistema,
      }
    );
    dispatch(getConvocatorias(data));
  } catch (error) {
    if (!error.response) {
      dispatch({
        type: GET_CONVOCATORIA,
      });
    } else {
      dispatch({
        type: GET_CONVOCATORIA_ERROR,
        payload: error.response.data,
      });
    }
  }
};

export const MaterialesINE = () => async (dispatch) => {
  try {
    const urls = await axios(window.location.origin + JSON_URL);
    const { data } = await axios.post(
      `${urls.data.urlServer}${urls.data.urlMaterialesApoyoINE}`
    );
    dispatch(linkMaterialesINE(data));
  } catch (error) {
    if (!error.response) {
      dispatch({
        type: GET_MATERIALES_APOYO_INE,
      });
    } else {
      dispatch({
        type: GET_OBT_SISTEMA_ERROR,
        payload: error.response.data,
      });
    }
  }
};

export const MaterialesOPLE = () => async (dispatch) => {
  try {
    const urls = await axios(window.location.origin + JSON_URL);
    const { data } = await axios.post(
      `${urls.data.urlServer}${urls.data.urlMaterialesApoyoOPLE}`
    );
    dispatch(linkMaterialesOPLE(data));
  } catch (error) {
    if (!error.response) {
      dispatch({
        type: GET_MATERIALES_APOYO_OPLE,
      });
    } else {
      dispatch({
        type: GET_OBT_SISTEMA_ERROR,
        payload: error.response.data,
      });
    }
  }
};

export const Registrarme = () => async (dispatch) => {
  try {
    const urls = await axios(window.location.origin + JSON_URL);
    const { data } = await axios.post(
      `${urls.data.urlServer}${urls.data.registrarme}`
    );
    dispatch(paramRegistrarme(data));
  } catch (error) {
    if (!error.response) {
      dispatch({
        type: GET_REGISTRARME,
      });
    } else {
      dispatch({
        type: GET_OBT_SISTEMA_ERROR,
        payload: error.response.data,
      });
    }
  }
};

export const IniciarSesion = () => async (dispatch) => {
  try {
    const urls = await axios(window.location.origin + JSON_URL);
    const { data } = await axios.post(
      `${urls.data.urlServer}${urls.data.iniciarSesion}`
    );
    dispatch(paramIniciarSesion(data));
  } catch (error) {
    if (!error.response) {
      dispatch({
        type: GET_MATERIALES_APOYO_OPLE,
      });
    } else {
      dispatch({
        type: GET_OBT_SISTEMA_ERROR,
        payload: error.response.data,
      });
    }
  }
};

export const getFechaPostulacion = () => async (dispatch) => {
  try {
    const urls = await axios(window.location.origin + JSON_URL);
    const { data } = await axios.post(
      `${urls.data.urlServer}${urls.data.urlFechaPostulacion}`
    );
    dispatch(paramFechaPostulacion(data));
  } catch (error) {
    if (!error.response) {
      dispatch({
        type: GET_MATERIALES_APOYO_OPLE,
      });
    } else {
      dispatch({
        type: GET_OBT_SISTEMA_ERROR,
        payload: error.response.data,
      });
    }
  }
};